import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { makeStyles } from "@material-ui/core/styles";

const useClasses = makeStyles({
  dialog: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    textAlign: "center",
    fontSize: "1.0vw",
  },
  iconRow: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "12px",
  },
  contentText: {
    textAlign: "center",
    marginBottom: "6px",
  },
  button: {
    width: "17.5%",
    margin: "0.5rem",
  },
});

export default function dialogPendingCascadeWarning(props) {
  const classes = useClasses();
  const assetName = props.assetName || "";
  const assetType = props.assetType || "asset";

  return (
    <Dialog fullWidth={true} open={props.isOpen} onClose={props.onDismiss}>
      <DialogTitle className={classes.title}>WARNING</DialogTitle>
      <DialogContent>
        <div className={classes.iconRow}>
          <ErrorOutlineIcon color="secondary" fontSize="large" />
        </div>
        <DialogContentText className={classes.contentText}>
          {`A ${assetType} deletion was interrupted when the page was refreshed.`}
        </DialogContentText>
        {assetName && (
          <DialogContentText color="primary" className={classes.contentText}>
            {assetName}
          </DialogContentText>
        )}
        <DialogContentText className={classes.contentText}>
          Affected versions will be repaired automatically when you open them.
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialog}>
        <Button color="primary" variant="contained" className={classes.button} onClick={props.onDismiss}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
